var React = require('react');
var Cookies = require('cookies-js');
var Constants = require('../Constants.js');
import { withRouter } from 'react-router'

var RedirectIfAuthenticated = React.createClass({
  componentWillMount: function() {
    console.log("RedirectIfAuthenticated will mount.");
    
    if( Cookies.get('jwtsession')) {
      this.props.router.push(`${Constants.APP_URL_PREFIX}/dashboard`);
    }
  },
  render: function () {
    return (
      <div className="RedirectIfAuthenticated component">
        {this.props.children}
      </div>
    );
  }
});

module.exports = withRouter(RedirectIfAuthenticated)


// WEBPACK FOOTER //
// ./src/components/auth/RedirectIfAuthenticated.js